import React, { useState } from 'react';
import '../styles/ClaimProfileFlow.css';
import '../App.css';
import '../styles/Conversation.css';
import Loading from './common/Loading';
import GmailIcon from '../assets/gmail-icon.png';
import { EmailThreadProps } from '../types/types';
import { getGmailUrl } from '../utils/CommonUtils';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

const Conversation: React.FC<EmailThreadProps> = ({
  emailAddress,
  recipientName,
}) => {
  const [loading, setLoading] = useState(false);
  const user = useSelector((state: RootState) => state.user);
  const handleGmailClick = () => {
    setLoading(true);
    setLoading(false);
    window.open(
      getGmailUrl(
        emailAddress,
        'Connecting Through BUILT',
        `Hello ${recipientName}, \n\nI came across your profile through BUILT and would love to connect. Let’s start a conversation and explore how we can collaborate!\n\nBest regards,\n${user.userDetails?.name}`,
        null,
      ),
      '_blank',
    );
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div
          className="icon-item"
          onClick={handleGmailClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleGmailClick();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <div className="icon-circle">
            <img src={GmailIcon} alt="Gmail" className="icon-image" />
          </div>
          <p className="icon-text">Gmail</p>
        </div>
      )}
    </>
  );
};

export default Conversation;
